<nb-card>
  <nb-card-header *ngIf="reportType === 'deposit'">لیست واریز کارت هدیه</nb-card-header>
  <nb-card-header *ngIf="reportType === 'withdraw'">لیست برداشت کارت هدیه</nb-card-header>
  <nb-card-body>
    <p-table
      [value]="response.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="true"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [loading]="loading"
      (onLazyLoad)="getGiftCardsList($event)"
      [lazyLoadOnInit]="false"
      [totalRecords]="response.totalRecords"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>ساخته شده توسط</th>
          <th>استفاده شده توسط</th>
          <th>ارز</th>
          <th>مقدار</th>
          <th>مقدار به تومان</th>
          <th>وضعیت</th>
          <th>تاریخ ایجاد</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td *ngIf="user.createdByUser.firstName && user.createdByUser.lastName; else empty">
            <a
              class="text-success"
              [routerLink]="'/dashboard/user/' + user.createdByUser.id"
              target="_blank"
            >
              {{ user.createdByUser.firstName }} {{ user.createdByUser.lastName }}
            </a>
          </td>
          <td *ngIf="user.redeemedByUser.firstName && user.redeemedByUser.lastName; else empty">
            <a
              class="text-success"
              [routerLink]="'/dashboard/user/' + user.redeemedByUser.id"
              target="_blank"
            >
              {{ user.redeemedByUser.firstName }} {{ user.redeemedByUser.lastName }}
            </a>
          </td>
          <td>{{ user.currency.name }}</td>
          <td>{{ user.giftcard.amount | number : '1.0-8' }}</td>
          <td>{{ user.giftcard.amountIRT | number : '1.0-0' }}</td>
          <td [class.text-success]="user.giftcard.status === GiftCardStatus.USED">
            {{ user.giftcard.status === GiftCardStatus.USED ? 'استفاده شده' : 'استفاده نشده' }}
          </td>
          <td>{{ user.giftcard.createdAt | dateFormat : 'jYYYY/jMM/jDD' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
<ng-template #empty>
  <td>-</td>
</ng-template>
